import { create } from 'zustand';
import { notificationsApi } from '@/api/notifications';
export const useNotificationsStore = create((set, get) => ({
    notifications: [],
    unreadCount: 0,
    isLoading: false,
    error: null,
    setNotifications: (notifications) => set({ notifications }),
    loadNotifications: async (tenantId, limit = 5) => {
        set({ isLoading: true, error: null });
        try {
            const data = await notificationsApi.getNotifications({ page: 1, pageSize: limit });
            set({ notifications: data.data, isLoading: false });
        }
        catch (err) {
            set({ error: 'Error cargando notificaciones', isLoading: false });
        }
    },
    loadUnreadCount: async (tenantId) => {
        try {
            const { unread } = await notificationsApi.getUnreadCount();
            set({ unreadCount: unread });
        }
        catch {
            // silent fail
        }
    },
    markAsRead: async (id) => {
        try {
            await notificationsApi.markAsRead(id);
            const updated = get().notifications.map(n => n.id === id ? { ...n, read: true } : n);
            set({
                notifications: updated,
                unreadCount: Math.max(0, get().unreadCount - 1),
            });
        }
        catch {
            // silent fail
        }
    },
    markAllAsRead: async () => {
        try {
            await notificationsApi.markAllAsRead();
            set({
                notifications: get().notifications.map(n => ({ ...n, read: true })),
                unreadCount: 0,
            });
        }
        catch {
            // silent fail
        }
    },
}));
//# sourceMappingURL=notifications.store.js.map